<template>
  <div>{{ $t('settings.change_pin.title') }}</div>
</template>

<script>
export default {}
</script>

<style lang="sass" scoped></style>
